import { render, staticRenderFns } from "./uby-excursions.vue?vue&type=template&id=245b1d41"
import script from "./uby-excursions.vue?vue&type=script&lang=js"
export * from "./uby-excursions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports